import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const PodWhatToExpectLanding = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Helmet>
        <title>What To Expect | Hire a POD</title>
        <meta
          name="description"
          content="Your Hire a POD request has been received. Here is what to expect next from HireX8."
        />
      </Helmet>

      <section className="py-16 sm:py-24 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center text-sm font-semibold text-orange-600 hover:opacity-80 mb-6">
            ← Back to HireX8
          </Link>

          <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 text-sm font-medium uppercase tracking-wider text-orange-600 mb-4">
              <span className="w-2 h-2 rounded-full bg-orange-500" />
              Hire a POD Request Received
            </div>

            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 mb-8">
              What To Expect
            </h1>

            <ol className="space-y-5 text-lg text-gray-700 leading-relaxed list-decimal pl-6">
              <li>Our team will contact you to confirm your delivery goals, technical scope, and priority timeline.</li>
              <li>Correspondence will be made via email, so please check your spam folder if you have not received a follow-up within 30 minutes.</li>
              <li>Within one business day, we will recommend a POD structure including Project Manager plus matched resources for your needs.</li>
              <li>You will receive a clear monthly delivery proposal starting at $3,500.00, including roles, cadence, and execution plan.</li>
              <li>Once approved, onboarding begins and your POD is launched with a dedicated delivery lead.</li>
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PodWhatToExpectLanding;
